export class EntTerritorialUnitsFilter {
  page: number;
  size: number;
  id: number | null;
  parentId: number | null;
  code?: string | null;
  areaCode?: string | null;
  type: string[] | null;
  name: string | null;

  constructor(init?: Partial<EntTerritorialUnitsFilter>) {
    this.parentId = null;
    this.areaCode = null;
    this.type = null;
    this.name = null;
    this.id = null;
    this.page = 1;
    this.size = 30;
    if (init) {
      Object.assign(this, init);
    }
  }
}
